export const LinkIcon = ({ size = 7, color = "#212529", ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M0.583333 0V1.16667H5.59417L0 6.76083L0.8225 7.58333L6.41667 1.98917V7H7.58333V0H0.583333Z" fill={color} />
        </svg>

    );
}; 